export default __webpack_public_path__ + "b13b74627fb260744d26a078eb68ad50.svg";